import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import ClientSelector from '../processFile/ClientSelector';
import CSVInput from '../processFile/CSVInput';
import CSVColumnSelector from '../processFile/CSVColumnSelector';
import Loading from '../processFile/Loading';
import AnalysisResult from '../processFile/AnalysisResult';
import ProcessButton from '../processFile/ProcessButton';
import Placeholder from './Placeholder';
import GraphIcon from './Graph-Icon.png';
import MapIcon from './Map-Icon.png';
import ClientIcon from './Select-Client-Icon.png'
import UploadIcon from './Upload-File-Icon.png'
import './Main.css';

// unload token on page close
window.onbeforeunload = function() {
    localStorage.removeItem('id_token');
};

class Main extends Component {
    constructor(props) {
        super(props);

        // Bind the this context to bind all of the handler functions
        this.uploadCSVHandler = this.uploadCSVHandler.bind(this);
        this.loadingAnimationHandler = this.loadingAnimationHandler.bind(this);
        this.noMapHandler = this.noMapHandler.bind(this);
        this.noGraphHandler = this.noGraphHandler.bind(this);
        this.graphHandler = this.graphHandler.bind(this);
        this.dataFieldsHandler = this.dataFieldsHandler.bind(this);
        this.noClientHandler = this.noClientHandler.bind(this);
        this.uploadHandler = this.uploadHandler.bind(this);
        this.pointAddressHandler = this.pointAddressHandler.bind(this);
        this.pointValueHandler = this.pointValueHandler.bind(this);
        this.pointOperatorHandler = this.pointOperatorHandler.bind(this);
        this.enableButtonHandler = this.enableButtonHandler.bind(this);

        // Set some state
        this.state = {
            noGraph: false,
            noClient: false,
            uploadIcon: false,
            loading: true,
            noMap: false,
            uploadCSV: false,
            setData: false,
            displayGraph: false,
            isBusy: false,
            csvData: {},
            chartData: {},
            pointAddress: null,
            pointValue: null,
            pointOperator : null
        }
    }

    pointAddressHandler(value){
        this.setState({
            pointAddress: value
        }, () =>{
            this.enableButtonHandler();
        });
    }

    pointValueHandler(value){
        this.setState({
            pointValue: value
        }, () =>{
            this.enableButtonHandler();
        });
    }

    pointOperatorHandler(value){
        this.setState({
            pointOperator: value
        }, () =>{
            this.enableButtonHandler();
        });
    }

    enableButtonHandler(){
        if(this.state.pointAddress !== null && this.state.pointValue !== null && this.state.pointOperator !== null){
            this.processButton.toggleButton(false);
        }
        else{
            this.processButton.toggleButton(true);
        }
    }


    loadingAnimationHandler(value){
        this.setState({
            loading: value
        })
    }

    uploadCSVHandler(value){
        this.setState({
            uploadCSV: value
        });
    }

    noMapHandler(value){
        this.setState({
            noMap: value
        });
    }

    noGraphHandler(value){
        this.setState({
            noGraph: value
        });
    }

    noClientHandler(value){
        this.setState({
            noClient: value
        });
    }

    uploadHandler(value){
        this.setState({
            uploadIcon: value
        });
    }

    graphHandler(value, data){
        this.setState({
            displayGraph: value,
            chartData: data,
            isBusy: false
        })
    }

    dataFieldsHandler(value, data){
        this.setState({
            setData: value,
            csvData: data,
        })
    }

    render() {
        var CSVButton = this.state.uploadCSV ? <CSVInput dataFields={this.dataFieldsHandler} noGraph={this.noGraphHandler} uploadIcon={this.uploadHandler} tableGraph={this.graphHandler}/> : "";
        var noGraph = this.state.noGraph ? <Placeholder graphic={GraphIcon} title="Run analysis" paragraph="Fill out the information and click the process button to analyze your EMS data."/> : "";
        var noMap = this.state.noMap ? <Placeholder graphic={MapIcon} title="There is not an EMS map available" paragraph="Please contact one of our engineers at support@cenergistic.com and we will create one for you."/> : "";
        var noClient = this.state.noClient ? <Placeholder graphic={ClientIcon} title="Please select a client" paragraph="Select a client from the dropdown above."/> : "";
        var uploadFile = this.state.uploadIcon ? <Placeholder graphic={UploadIcon} title="Upload your EMS file" paragraph="Please upload the csv file expoted from your EMS."/> : ""; 
        var loadingGraphic = this.state.loading ? <Loading /> : "";
        var processButton = this.state.setData ? <ProcessButton loading={this.loadingAnimationHandler} graph={this.graphHandler} noGraph={this.noGraphHandler} onRef={ref =>(this.processButton = ref)}
                                                                pointAddress={this.state.pointAddress} pointValue={this.state.pointValue} pointOperator={this.state.pointOperator}/> : "";
        var tableGraph = this.state.displayGraph ? <AnalysisResult data={this.state.chartData} /> : "";
        var pointAddress = this.state.setData ? <CSVColumnSelector data={this.state.csvData} handler={this.pointAddressHandler} graph={this.graphHandler} name={"Select Point Address Column"} id={"addSel"}/> : "";
        var pointValue = this.state.setData ? <CSVColumnSelector data={this.state.csvData} handler={this.pointValueHandler} graph={this.graphHandler} name={"Select Point Value Column"} id={"numSel"}/> : "";
        var pointOperator = this.state.setData ? <CSVColumnSelector data={this.state.csvData} handler={this.pointOperatorHandler} graph={this.graphHandler} name={"Select Point Operator Column"} id={"opeSel"}/> : "";

        return (
            <Container className="Main-Container">
                <Row>
                    <Col className="Main-Top" id="Main-Client-Selector" lg="6"><ClientSelector 
                                    uploadCSV={this.uploadCSVHandler} 
                                    loading={this.loadingAnimationHandler} 
                                    noGraph={this.noGraphHandler} 
                                    noMap={this.noMapHandler} 
                                    noClient={this.noClientHandler}
                                    uploadIcon={this.uploadHandler}
                                    setData={this.dataFieldsHandler}
                                    tableGraph={this.graphHandler}/></Col>
                    <Col className="Main-Top" lg="6">{CSVButton}</Col>
                </Row>
                <Row>
                    {pointAddress}
                    {pointValue}
                    {pointOperator}
                </Row>
                <Row>
                    {processButton}
                </Row>
                {loadingGraphic}
                {noClient}
                {noGraph}
                {uploadFile}
                {noMap}
                {tableGraph}
            </Container>
        );
    }
}
export default Main;
